import { render, staticRenderFns } from "./TextModal.vue?vue&type=template&id=1414e944&scoped=true"
import script from "./TextModal.vue?vue&type=script&lang=ts"
export * from "./TextModal.vue?vue&type=script&lang=ts"
import style0 from "./TextModal.vue?vue&type=style&index=0&id=1414e944&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1414e944",
  null
  
)

export default component.exports